var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import RegexStr from "../../../common/RegexStr";
import ClientService from '../../../api/ClientService';
import CommonService from "../../../api/CommonService";
var phoneRegex = new RegExp(RegexStr.mobile);
var PhoneInfo = (function (_super) {
    __extends(PhoneInfo, _super);
    function PhoneInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.business_id = '';
        _this.supplier_to_business_id = '';
        _this.newPhone = '';
        _this.verifyCode = '';
        _this.remainSeconds = 60;
        _this.timer = null;
        _this.canGetCode = true;
        _this.handleType = '1';
        _this.is_freeze = 0;
        return _this;
    }
    PhoneInfo.prototype.created = function () {
        this.service = ClientService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    PhoneInfo.prototype.clearTimer = function () {
        clearInterval(this.timer);
        this.timer = null;
        this.remainTime = 60;
        this.canGetCode = true;
    };
    PhoneInfo.prototype.sendCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var valid;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.timer)
                            return [2];
                        if (!phoneRegex.test(this.phone)) {
                            this.$message.error('手机号格式不正确！');
                            return [2];
                        }
                        return [4, this.checkPhoneUsable(1)];
                    case 1:
                        valid = _a.sent();
                        if (!valid)
                            return [2];
                        this.commonService.sendCode({ phone: this.phone, type: 8 }).then(function (res) {
                            _this.$message.success('发送成功！');
                        }, function (error) {
                            _this.$message.error(error.message);
                        });
                        this.canGetCode = false;
                        this.timer = setInterval(function () {
                            _this.remainSeconds--;
                            if (_this.remainSeconds === 0) {
                                _this.clearTimer();
                            }
                        }, 1000);
                        return [2];
                }
            });
        });
    };
    PhoneInfo.prototype.close = function () {
        this.$closeDialog();
        this.$emit('closeDiolog', false);
    };
    PhoneInfo.prototype.checkPhoneUsable = function (type) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                        var postData;
                        var _this = this;
                        return __generator(this, function (_a) {
                            postData = {
                                type: type,
                                phone: type == 1 ? this.phone : this.newPhone,
                                business_id: this.business_id,
                                supplier_to_business_id: this.supplier_to_business_id
                            };
                            this.service.checkPhoneUsable(postData).then(function (res) {
                                var _a = res.data, success = _a.success, msg = _a.msg;
                                if (success)
                                    resolve(true);
                                else {
                                    _this.$message.error(msg || '账号已注册，请使用其它手机号');
                                    resolve(false);
                                }
                            }, function (err) {
                                console.log('------reject checkPhoneUsable', err);
                                _this.$message.error(err.message || '账号已注册，请使用其它手机号');
                                resolve(false);
                            });
                            return [2];
                        });
                    }); })];
            });
        });
    };
    PhoneInfo.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var valid, postData, _a, success, msg, e_1, data, _b, success, msg, _c, success, msg, e_2;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(this.handleType === '1')) return [3, 6];
                        if (!phoneRegex.test(this.newPhone)) {
                            this.$message.warning('手机号格式有误');
                            return [2];
                        }
                        return [4, this.checkPhoneUsable(2)];
                    case 1:
                        valid = _d.sent();
                        if (!valid)
                            return [2];
                        _d.label = 2;
                    case 2:
                        _d.trys.push([2, 4, , 5]);
                        postData = {
                            business_id: this.business_id,
                            supplier_to_business_id: this.supplier_to_business_id,
                            old_phone: this.phone,
                            new_phone: this.newPhone,
                            smscode: this.verifyCode
                        };
                        return [4, this.service.updatePhoneUsable(postData)];
                    case 3:
                        _a = (_d.sent()).data, success = _a.success, msg = _a.msg;
                        if (success) {
                            this.$message.success('操作成功');
                            this.$emit('save:ok');
                            this.close();
                        }
                        else {
                            this.$message.error(msg || '操作失败');
                        }
                        return [3, 5];
                    case 4:
                        e_1 = _d.sent();
                        this.$message.error(e_1.message || '操作失败');
                        return [3, 5];
                    case 5: return [3, 13];
                    case 6:
                        if (!(this.handleType === '2')) return [3, 13];
                        _d.label = 7;
                    case 7:
                        _d.trys.push([7, 12, , 13]);
                        data = {
                            supplier_to_business_id: this.supplier_to_business_id
                        };
                        console.log(data);
                        if (!(this.is_freeze === 0)) return [3, 9];
                        return [4, this.service.freezeShopping(data)];
                    case 8:
                        _b = (_d.sent()).data, success = _b.success, msg = _b.msg;
                        if (success) {
                            this.$message.success(msg);
                            this.$emit('save:ok');
                            this.close();
                        }
                        else {
                            this.$message.error(msg || '操作失败');
                        }
                        return [3, 11];
                    case 9:
                        if (!(this.is_freeze === 1)) return [3, 11];
                        return [4, this.service.unfreezeShopping(data)];
                    case 10:
                        _c = (_d.sent()).data, success = _c.success, msg = _c.msg;
                        if (success) {
                            this.$message.success(msg);
                            this.$emit('save:ok');
                            this.close();
                        }
                        else {
                            this.$message.error(msg || '操作失败');
                        }
                        _d.label = 11;
                    case 11: return [3, 13];
                    case 12:
                        e_2 = _d.sent();
                        this.$message.error(e_2.message || '操作失败');
                        return [3, 13];
                    case 13: return [2];
                }
            });
        });
    };
    __decorate([
        Prop({
            type: String,
            default: ''
        })
    ], PhoneInfo.prototype, "phone", void 0);
    PhoneInfo = __decorate([
        Component({
            computed: {
                isValid: function () {
                    return this.verifyCode.length > 5 && this.newPhone.length === 11;
                }
            }
        })
    ], PhoneInfo);
    return PhoneInfo;
}(VueDialog));
export default PhoneInfo;
